<template>
  <div class="contact-us">
    <div class="page-title">
      联系我们
    </div>
    <div class="info">
      <el-row :gutter="20">
        <el-col :span="8" :offset="0">
          <div class="f-t">
            <i class="el-icon-map-location m-icon"></i>
            <div>
              <div class="title">公司地址</div>
              <div>成都市青羊区光华东三路486号2栋14层1401号</div>
            </div>
          </div>
        </el-col>
        <el-col :span="8" :offset="0">
          <div class="f-t">
            <i class="el-icon-phone-outline m-icon"></i>
            <div>
              <div class="title">联系电话</div>
              <div>028-86530702</div>
            </div>
          </div>
        </el-col>
        <el-col :span="8" :offset="0">
          <div class="f-t">
            <i class="el-icon-time m-icon"></i>
            <div>
              <div class="title">服务时间</div>
              <div>周一至周五9:00-18:00（法定假日除外）</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="map-area">
      <baidu-map class="bm-view" ak="Jqeq0oFwv5rXjF2xWC6SyGRRAaDv0nJO" :center="center" :zoom="zoom" @ready="handler" scroll-wheel-zoom>
        <bm-marker :position="center">
          <bm-label content="威格罗（成都）生物科技有限公司" :labelStyle="{color: '#303133', fontSize : '12px', border : 'none'}" :offset="{width: -35, height: 30}"/>
        </bm-marker>
      </baidu-map>
    </div>
  </div>
</template>

<script>
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import { BmMarker, BmLabel } from 'vue-baidu-map'
export default {
  components: {
    BaiduMap,
    BmMarker,
    BmLabel
  },
  data () {
    return {
      center: { lng: 0, lat: 0 },
      zoom: 15
    }
  },
  methods: {
    handler ({ BMap, map }) {
      this.center.lng = 103.968907
      this.center.lat = 30.678272
      this.zoom = 15
    }
  }
}
</script>

<style scoped>
.contact-us{
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 50px 0 50px;
}
.page-title{
  font-size: 32px;
  font-style: italic;
  padding-bottom: 40px;
  border-bottom: 1px solid #cccccc;
  margin-bottom: 30px;
}
.info{
  font-size: 15px;
  color: #606266;
}
.map-area{
  margin-top: 50px;
}
.bm-view{
  width: 100%;
  height: 500px;
  color: #606266;
}
.f-t{
  display: flex;
}
.m-icon{
  padding: 5px 20px;
  font-size: 24px;
}
.title{
  font-size: 20px;
  font-weight: bold;
  line-height: 38px;
  margin-bottom: 10px;
  color: #303133;
}
</style>
